export enum NotificationType {
    None = 'none',
    Email = 'email',
    Push = 'push',
    EmailAndPush = 'emailAndPush',
}